import React,{useState} from "react";
import "./faqsection.css";
import "./app-wide.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";




const FaqSection = () => {

    const faqQuestionAndAnswer = [
        {
            question: "What are the stock and etf does stock archives api support?",
            answer: "The Stock Archives API currently support the following:",
            supplement: ["AAPL", "NVDA", "MSFT", "AMZN", "GOOGL", "GOOG", "META", "WHR", "JWN", "AVGO", "JPM", "MA", "PFE"]
        },{
            question: "What are some supplement data that are provided by stock archives api?",
            answer: "The Stock Archives currently has the follow supplement information:",
            supplement:["CPI","GDP", "Real GDP", "NonFarm Payroll", "Unemployment", "30 Year Mortgage", "Etc."]

        },{
            question: "How far back of data does stock archives api support?",
            answer: "The following range of date that we have supported:",
            supplement: ["2023","2024"]
        }
    ];





    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAnswer = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
  
    return (
      <div className="section-container-faq-right">
        {faqQuestionAndAnswer.map((faq, index) => (
          <div className="faq-inner-section" key={index} onClick={() => toggleAnswer(index)}>
            <div className="question-top">
              <h3 className="question-section">{faq.question}</h3>
              <div className="question-button-section">
                <button className="question-section-button" onClick={() => toggleAnswer(index)}>
                    {activeIndex === index ? <FaMinus className="question-section-button-logo"/> : <FaPlus className="question-section-button-logo" />}
                </button>
              </div>
            </div>
  
            <div
              className={`answer-section ${activeIndex === index ? "visible" : "hidden"}`}
            >
              <p className="answer-text">{faq.answer}</p>
              <ul className="supplement-list">
                {faq.supplement.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default FaqSection;
  